<div class="tw-w-full tw-h-fit tw-min-w-full tw-max-w-full tw-bg-background">
  <div class="tw-w-full tw-h-fit tw-max-w-screen-xl tw-mx-auto tw-bg-background">
    <div class="tw-w-full tw-min-h-screen tw-flex tw-flex-col tw-bg-background">
      <div class="tw-w-full tw-h-fit tw-sticky tw-top-5 tw-bg-transparent tw-z-[999] tw-px-8 md:tw-px-16">
        <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-justify-between tw-items-center tw-bg-secondary tw-border tw-border-white/10 tw-rounded-[10px] tw-gap-2 tw-px-2 md:tw-px-4 tw-py-1">
          <div class="tw-w-fit tw-h-fit tw-flex tw-justify-start tw-items-center">
            <div class="tw-w-fit tw-h-full">
              <img class="tw-max-w-24 tw-min-h-12 tw-max-h-12 tw-object-contain tw-rounded-lg" src="../../../assets/logo.svg" />
            </div>
          </div>

          <div class="tw-w-fit tw-min-w-max tw-h-full tw-flex tw-justify-center tw-items-center tw-gap-2 md:tw-gap-4 tw-py-2 tw-relative">
            <button (click)="goToLogin()" class="tw-w-fit tw-h-fit tw-bg-tertiary tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-rounded-[5px] tw-px-4 tw-py-2">
              {{ "login" | translate }}
            </button>
            <p-dropdown
              class="language-flag-dropdown tw-border tw-border-white tw-rounded-[5px] tw-absolute tw-z-[1000]"
              [options]="languages"
              [(ngModel)]="selectedLanguage"
              [dataKey]="'id'"
              [filter]="false"
              [showClear]="false"
              [placeholder]="'language' | translate"
              (onChange)="setLanguage($event)"
            >
              <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-white">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <span class="fi fi-{{ selectedOption.flag }}"></span>
                </div>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <span class="fi fi-{{ item.flag }}"></span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
      </div>
      <div class="tw-w-full tw-h-fit tw-relative tw-px-8 md:tw-px-16">
        <div class="tw-w-full tw-h-fit tw-mt-12 md:tw-mt-12">
          <div class="tw-w-full tw-h-fit tw-flex tw-flex-col md:tw-flex-row tw-gap-4 tw-mb-5">
            <div class="tw-flex tw-items-center tw-gap-4">
              <div (click)="goBack()" class="tw-w-10 tw-h-10 tw-flex tw-justify-center tw-items-center tw-bg-white tw-border tw-border-grey-100 tw-rounded-full tw-cursor-pointer">
                <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/back-icon.svg" />
              </div>
              <p class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary">{{ "terms-of-service" | translate }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Terms of Service Content -->
      <div class="tw-w-full tw-h-fit tw-px-8 md:tw-px-16 tw-py-8">
        <div class="tw-w-full tw-h-fit tw-bg-white tw-rounded-[10px] tw-p-8">
          <div class="tw-mb-8">
            <h2 class="tw-font-poppins tw-font-bold tw-text-2xl tw-text-secondary tw-mb-4">{{ "terms-of-service" | translate }}</h2>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-600 tw-mb-4">{{ "last-updated" | translate }}: {{ currentDate | date: "longDate" }}</p>
          </div>

          <!-- Introduction -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">1. {{ "acceptance-of-terms" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "terms-intro-1" | translate }}
            </p>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "terms-intro-2" | translate }}
            </p>
          </div>

          <!-- Description of Service -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">2. {{ "description-of-service" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">{{ "service-description" | translate }}</p>
            <ul class="tw-list-disc tw-ml-6 tw-mb-4">
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "service-1" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "service-2" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "service-3" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "service-4" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "service-5" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "service-6" | translate }}</li>
            </ul>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "service-modification" | translate }}
            </p>
          </div>

          <!-- User Accounts -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">3. {{ "user-accounts" | translate }}</h3>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">3.1 {{ "account-creation" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "account-creation-desc" | translate }}
            </p>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">3.2 {{ "account-security" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "account-security-desc" | translate }}
            </p>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">3.3 {{ "account-termination" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "account-termination-desc" | translate }}
            </p>
          </div>

          <!-- User Conduct -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">4. {{ "user-conduct" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">{{ "conduct-description" | translate }}</p>
            <ul class="tw-list-disc tw-ml-6 tw-mb-4">
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "conduct-1" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "conduct-2" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "conduct-3" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "conduct-4" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "conduct-5" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "conduct-6" | translate }}</li>
              <li class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">{{ "conduct-7" | translate }}</li>
            </ul>
          </div>

          <!-- Payment Terms -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">5. {{ "payment-terms" | translate }}</h3>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">5.1 {{ "fees-and-billing" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "fees-description" | translate }}
            </p>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">5.2 {{ "payment-processing" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "payment-desc" | translate }}
            </p>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">5.3 {{ "transaction-fees" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "transaction-desc" | translate }}
            </p>
          </div>

          <!-- Intellectual Property -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">6. {{ "intellectual-property" | translate }}</h3>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">6.1 {{ "our-rights" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "ip-our-rights" | translate }}
            </p>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">6.2 {{ "your-content" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "ip-your-content" | translate }}
            </p>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">6.3 {{ "feedback" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "feedback-desc" | translate }}
            </p>
          </div>

          <!-- Privacy and Data Protection -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">7. {{ "privacy-data-protection" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "privacy-desc-1" | translate }}
            </p>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "privacy-desc-2" | translate }}
            </p>
          </div>

          <!-- Third-Party Services -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">8. {{ "third-party-services-terms" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "third-party-terms-1" | translate }}
            </p>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "third-party-terms-2" | translate }}
            </p>
          </div>

          <!-- Disclaimers -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">9. {{ "disclaimers" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "disclaimers-desc-1" | translate }}
            </p>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "disclaimers-desc-2" | translate }}
            </p>
          </div>

          <!-- Limitation of Liability -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">10. {{ "limitation-of-liability" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "liability-desc-1" | translate }}
            </p>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "liability-desc-2" | translate }}
            </p>
          </div>

          <!-- Indemnification -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">11. {{ "indemnification" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "indemnification-desc" | translate }}
            </p>
          </div>

          <!-- Termination -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">12. {{ "termination" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "termination-desc-1" | translate }}
            </p>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "termination-desc-2" | translate }}
            </p>
          </div>

          <!-- Governing Law -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">13. {{ "governing-law" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "governing-desc-1" | translate }}
            </p>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "governing-desc-2" | translate }}
            </p>
          </div>

          <!-- Changes to Terms -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">14. {{ "changes-to-terms" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "changes-terms-desc" | translate }}
            </p>
          </div>

          <!-- Miscellaneous -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">15. {{ "miscellaneous" | translate }}</h3>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">15.1 {{ "entire-agreement" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "entire-agreement-desc" | translate }}
            </p>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">15.2 {{ "severability" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "severability-desc" | translate }}
            </p>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">15.3 {{ "waiver" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">
              {{ "waiver-desc" | translate }}
            </p>

            <h4 class="tw-font-poppins tw-font-medium tw-text-base tw-text-secondary tw-mb-3">15.4 {{ "assignment" | translate }}</h4>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-leading-relaxed">
              {{ "assignment-desc" | translate }}
            </p>
          </div>

          <!-- Contact Information -->
          <div class="tw-mb-8">
            <h3 class="tw-font-poppins tw-font-semibold tw-text-lg tw-text-secondary tw-mb-4">16. {{ "contact-us" | translate }}</h3>
            <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-4 tw-leading-relaxed">{{ "contact-terms-description" | translate }}</p>
            <div class="tw-bg-gray-50 tw-p-4 tw-rounded-lg">
              <p class="tw-font-poppins tw-text-sm tw-text-gray-700 tw-mb-2">
                <strong>{{ "email" | translate }}:</strong> {{ teveniEmail }}
              </p>
            </div>
          </div>

          <!-- Effective Date -->
          <div class="tw-mb-4">
            <p class="tw-font-poppins tw-text-xs tw-text-gray-500 tw-text-center">
              {{ "effective-date-terms" | translate }}
            </p>
          </div>
        </div>
      </div>

      <div class="tw-w-full tw-h-5 max-2xl:tw-hidden"></div>
      <!-- Footer -->
      <div class="tw-w-full tw-h-fit tw-bg-secondary 2xl:tw-rounded-[10px] tw-px-8 md:tw-px-16 tw-py-4 md:tw-pt-10 !tw-z-[3]">
        <div class="tw-w-full tw-flex max-md:tw-flex-col tw-justify-between tw-gap-10 md:tw-mb-10">
          <div class="tw-w-full md:tw-max-w-xs tw-flex tw-flex-col tw-gap-4">
            <div class="tw-w-fit tw-h-full">
              <img class="tw-max-w-24 tw-min-h-12 tw-max-h-12 tw-object-contain tw-rounded-lg" src="../../../assets/logo.svg" />
            </div>
            <p class="tw-font-poppins tw-text-xs tw-text-white/50">{{ "home-description" | translate }}</p>
            <div class="tw-flex tw-items-center tw-gap-4">
              <img class="tw-min-w-6 tw-max-w-6 tw-min-h-6 tw-max-h-6 tw-object-contain tw-cursor-pointer" (click)="goToSocilMedia('instagram')" src="../../../assets/footer-instagram-icon.svg" />
              <img class="tw-min-w-6 tw-max-w-6 tw-min-h-6 tw-max-h-6 tw-object-contain tw-cursor-pointer" (click)="goToSocilMedia('facebook')" src="../../../assets/footer-facebook-icon.svg" />
              <img class="tw-min-w-6 tw-max-w-6 tw-min-h-6 tw-max-h-6 tw-object-contain tw-cursor-pointer" (click)="goToSocilMedia('tiktok')" src="../../../assets/footer-tiktok-icon.svg" />
            </div>
          </div>

          <div class="tw-flex tw-gap-16 max-md:tw-gap-10">
            <div class="tw-flex tw-flex-col tw-gap-3">
              <p class="tw-font-poppins tw-font-semibold tw-text-xs tw-text-white/40 tw-uppercase tw-tracking-wider">{{ "legal" | translate }}</p>
              <p (click)="goToPrivacyPolicy()" class="tw-font-poppins tw-text-xs tw-text-white/70 hover:tw-text-white tw-cursor-pointer">{{ "privacy-policy" | translate }}</p>
              <p (click)="goToTermsOfService()" class="tw-font-poppins tw-text-xs tw-text-white/70 hover:tw-text-white tw-cursor-pointer">{{ "terms-of-service" | translate }}</p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-fit">
            <p class="tw-font-poppins tw-font-semibold tw-text-xs tw-text-white/50 tw-mb-4">{{ "create-an-account-footer-label" | translate }}</p>
            <button (click)="goToRegister()" class="tw-w-full md:tw-min-w-[150px] tw-bg-primary tw-font-poppins tw-font-semibold tw-text-xs tw-text-secondary tw-rounded-[5px] tw-px-4 tw-py-3">
              {{ "create-a-business-account" | translate }}
            </button>
          </div>
        </div>

        <div class="tw-w-full tw-h-px tw-bg-white/10 tw-my-6"></div>

        <p class="tw-font-poppins tw-text-xs tw-text-white/40 tw-text-center">{{ "copyright" | translate }}</p>
      </div>
      <div class="tw-w-full tw-h-5 max-2xl:tw-hidden"></div>
    </div>
  </div>
</div>
